import Tick from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Tick24PxOutlined";
import styles from "./DeliveryHighlightMessage.module.scss";
import { ClickAndCollectMessage } from "./ClickAndCollectMessage";

export type Props = {
  /**
   * A string representing the message.
   */
  message: string;
  /**
   * A boolean indicating whether to show the extended returns message.
   */
  showExtendedReturnsMessage: boolean;
  /**
   * A boolean indicating whether click and collect is available for selected variant.
   */
  isClickAndCollectAvailable: boolean;
  /**
   * A boolean indicating whether price of the product is above the click and collect threshold.
   */
  isOverClickAndCollectThreshold: boolean;
  /**
   * A toggle indicating when and how to show the click and collect message.
   */
  showClickAndCollect?: "never" | "available" | "always";
  /**
   * A boolean indicating whether to show free returns message.
   */
  showFreeReturns?: boolean;
  /**
   * A boolean indicating whether to show free returns message with restrictions.
   */
  showFreeReturnsWithRestrictions?: boolean;
};

export const DeliveryHighlightMessageUI = ({
  message,
  showExtendedReturnsMessage,
  isClickAndCollectAvailable,
  isOverClickAndCollectThreshold,
  showClickAndCollect = "never",
  showFreeReturns = false,
  showFreeReturnsWithRestrictions = false,
}: Props) => {
  const showClickAndCollectMessage =
    showClickAndCollect === "always" ||
    (showClickAndCollect === "available" && isClickAndCollectAvailable);

  return (
    <>
      <div data-testid="product:delivery-message" className={styles.message}>
        <div className={styles.deliveryMessage}>
          <Tick />
          <span>{message}</span>
        </div>
      </div>
      {showClickAndCollectMessage && (
        <div data-testid="product:delivery-message" className={styles.message}>
          <ClickAndCollectMessage
            isClickAndCollectAvailable={isClickAndCollectAvailable}
            isOverClickAndCollectThreshold={isOverClickAndCollectThreshold}
          />
        </div>
      )}
      {showFreeReturns && (
        <div data-testid="product:delivery-message" className={styles.message}>
          <div className={styles.deliveryMessage}>
            <Tick />
            <span>
              Free returns
              {showFreeReturnsWithRestrictions ? ", restrictions apply" : ""}
            </span>
          </div>
        </div>
      )}
      {showExtendedReturnsMessage && (
        <div data-testid="product:delivery-message" className={styles.message}>
          <div className={styles.deliveryMessage}>
            <Tick />
            <span>Extended returns until 23 January 2024</span>
          </div>
        </div>
      )}
    </>
  );
};
